'use strict';

var $ = require('jquery');
var ajax = require('../../utils/ajax');
var util = require('../../utils/util');
var progress = require('../../utils/progress');
var toggle = require('../../components/toggle');
var flyin = require('../../flyins/flyin');
var pdpsize = require('../../components/product/pdpsize');
var lazyload = require('../../utils/lazyload');
var wishlist = require('../wishlist');
var offcanvasdialog = require('../../components/offcanvasdialog');
var quickshop = require('../../components/product/quickshop');
var uniform = require('../../components/uniform');
var variationValidation = require('./validVariation.js');
var variationCarousel = require('../../productdetail/variation-carousel');

function init() {
    var $addToCart = $('#add-to-cart');
    var $addAllToCart = $('#add-all-to-cart');
    var $stickyAddAllToCart = $('#add-to-cart-sticky');
    var $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart-container:not(.m-product-set) button.add-to-cart-disabled').length) {
            $addAllToCart.addClass('add-to-cart-disabled');
            $stickyAddAllToCart.addClass('add-to-cart-disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeClass('add-to-cart-disabled');
            $addToCart.removeAttr('disabled');
            $stickyAddAllToCart.removeClass('add-to-cart-disabled');
        }
    };

    var updateTotalPrice = function ($target) {
        let $setPriceElement = $('.product-set-price');
        let $updatedPrice = $target.find('.product-set-total').text();
        $setPriceElement.text($updatedPrice);
    };

    var removeCosmeticContent = function () {
        var targets = [
            '.product-set-item .price-cokpit .cosmetic-content',
            '.quick-shop-set .price-cokpit .cosmetic-content',
            '.product-set-item .product-set-info .component.price .price-additional-info',
            '.quick-shop-set .product-price .component.price .price-additional-info'
        ];
        $(targets.join(', ')).remove();
    };

    var initPdpSize = function () {
        $productSetList.find('.product-set-item').each(function () {
            pdpsize.init('#' + this.id);
            // workaround for unchecked region-radios
            $(this)
                .find('.attribute.size .sizes-wrapper .regions input')
                .each(function () {
                    if ($(this).attr('checked') && !$(this).parent('span').hasClass('checked')) {
                        $(this).parent('span').addClass('checked');
                    }
                });
        });
    };

    var updateDropdown = function (selectedElement, shouldNotShow) {
        var dropdown = $(selectedElement).find('.width-size-dropdown-wrapper');
        var text = dropdown.find('.selection-text span');
        var widthSwatches = dropdown.find('.swatches.width');
        var sizeSwatches = dropdown.find('.swatches.size .activeSize');

        var selectedWidth;
        var selectedSize;

        var selectedWidthValue = '';
        var selectedSizeValue = '';

        if (widthSwatches && widthSwatches.find('.selected').length > 0) {
            selectedWidth = widthSwatches.find('.selected');
            selectedWidthValue = selectedWidth.find('.swatchanchor').attr('data-value');
        }

        if (sizeSwatches && sizeSwatches.find('.selected').length > 0) {
            selectedSize = sizeSwatches.find('.selected');
            selectedSizeValue = selectedSize.find('.swatchanchor').attr('data-size');
        }

        if (selectedSizeValue && selectedWidthValue) {
            text.removeClass('not-selected');
            text.html('<p>' + selectedWidthValue + '</p><p> ' + selectedSizeValue + '</p>');
        } else if (selectedSizeValue) {
            text.html(selectedSizeValue);
        } else {
            if (!shouldNotShow) {
                dropdown.find('.width-sizes-wrapper').show();
                dropdown.find('.selection-icon-down').removeClass('active');
                dropdown.find('.selection-icon-up').addClass('active');
            }
        }
    };

    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        let $this = $(this);
        let productSetSelectedDataObj = {};

        e.preventDefault();
        if ($this.parents('li').hasClass('unselectable')) {
            return;
        }
        let url = $this.data('selectionurl');
        const $container = $(this).parents('.product-set-item');
        const containerSelector = '#' + $container[0].id;
        const selectedPid = $container.find('.product-set-item-price').data('pid');
        const qty = $container.find('form input[name="Quantity"]').first().val();
        progress.show($('#pdpMain'));

        $('.product-set-item .product-set-item-price').each(function () {
            let pid = this.dataset && this.dataset.pid;
            if (pid != selectedPid) {
                productSetSelectedDataObj[pid] = this.dataset && this.dataset.price && parseFloat(this.dataset.price);
            }
        });

        const params = {
            Quantity: isNaN(qty) ? '1' : qty,
            productSetSelectedDataObj: JSON.stringify(productSetSelectedDataObj)
        };

        if ($this.hasClass('color')) {
            params.isColorChange = true;
        }

        ajax.load({
            url: util.appendParamsToUrl(url, params),
            target: $container,
            callback: function () {
                flyin.init();
                variationValidation.initSetProductValidation();
                pdpsize.init(containerSelector);
                uniform();
                variationCarousel.init();
                toggle.init();
                wishlist.init(true);
                lazyload.init();
                variationValidation.validateSetProduct(false, $container);
                updateAddToCartButtons();
                updateTotalPrice($container);
                removeCosmeticContent();
                updateDropdown(containerSelector);
            }
        });
    });

    $('body').on('click', '.quickshop-tab:not(.selected)', function () {
        $('.quickshop-tab').toggleClass('selected');
        $('.quickshop-tab-content').toggleClass('active');
    });

    // init product set
    if ($productSetList.length) {
        uniform();
        initPdpSize();
        variationValidation.initSetProductValidation();
        $('.product-set-item').each(function () {
            updateDropdown('#' + this.id, true);
        });
        updateAddToCartButtons();
        removeCosmeticContent();
    }
}

module.exports = function () {
    // init product set conditionally
    if ($('#product-set-list').length) {
        init();
    }
};
